import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, ModelObjectWithDirtyCheck, type ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"
import { EnumDocumentFileType } from "./enums/enumDocumentFileType.generated";

// Model Objects

export class ItemDocumentService extends ServiceBase {

  public async generateMaterialLabel(stockItemId: Guid, documentFormat: EnumDocumentFileType, quantity: number, useByDate: LocalDate | null, creationDate: LocalDate | null, batchNumber: string, documentTemplateId: Guid | null, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<Uint8Array> {
    const req = {
    tenantId:api.tenantId.toString(),
    stockItemId:stockItemId.toString(),
    documentFormat:documentFormat.value,
    quantity:quantity,
    useByDate:useByDate == null ? null : useByDate.toString(),
    creationDate:creationDate == null ? null : creationDate.toString(),
    batchNumber:batchNumber,
    documentTemplateId:documentTemplateId == null ? null : documentTemplateId.toString(),
    };
    const extractor = (response:any) => converters.base64ToUint8Array(response.documentBytes);;
    return this.makeJsonRequest("itemDocument/v1/generateMaterialLabel", req, false, extractor, opts);
  };
}

export const itemDocumentService = new ItemDocumentService();